<template>
	<div @click="openDocs">
		<slot />
	</div>
</template>

<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { setDocsOpen } from '@/store/modules/onboarding/actions';

export default {
	name: 'DocsDispatcher',
	props: {
		docsSrc: { type: String },
	},
	methods: {
		...mapActionsShorthand({ setDocsOpen }),
		openDocs() {
			this.setDocsOpen(this.docsSrc);
		},
	},
};
</script>
